import { apiClient } from './base';

export const getUserActivity = (params) =>
  apiClient.get('/callcenter-performance/user-activity', { params }).then(r => r.data);

export const getUserSuccessRate = (params) =>
  apiClient.get('/callcenter-performance/user-success-rate', { params }).then(r => r.data);

export const getCallcenterPerformanceUsers = () =>
  apiClient.get('/callcenter-performance/users').then(r => r.data);
